import Cache from '@fs/zion-cache'
import type { FamilyMembers } from '@fs/zion-tree-types'
import type { SwrResponse } from './useSwrRequest'
import { useSwrRequest } from './useSwrRequest'

export const familyMembersCache = new Cache({
  storeName: 'familyMembers_r9',
  encrypted: process.env.NODE_ENV === 'production',
})

export const swrKey = (pid: string): string =>
  pid ? `/service/tree/tree-data/r9/family-members/person/${pid}?includePhotos=true` : ''

/**
 * Spouse and parent families of any person, not only the focus person (e.g. a parent's other marriages).
 * Shares the focus person's cache and keys, so a person already loaded elsewhere isn't refetched.
 */
export default function usePersonFamilyMembers(pid: string | undefined): SwrResponse<FamilyMembers> {
  return useSwrRequest<FamilyMembers>(pid ? swrKey(pid) : null, familyMembersCache, { revalidateOnFocus: false })
}
